import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import PracticasEnviar from "./app/components/practicas/practicas-enviar/practicas-enviar";
import PracticasInformes from "./app/components/practicas/practicas-informes/practicas-informes";
import PracticasList from "./app/components/practicas/practicas-list/practicas-list";
import PracticasRemitoAdmin from "./app/components/practicas/practicas-remito-admin/practicas-remito-admin";
import PrecargaSempre from "./app/components/practicas/precarga-sempre/precarga-sempre";
import DashboardPage from "./app/pages";
import OrdersPage from "./app/pages/orders";
import CredentialsSignInPage from "./app/pages/sign-in";
import PortalHome from "./app/pages/portal/PortalHome";
import { PortalHome2 } from "./app/pages/portal/PortalHome2";
import { PortalHome3 } from "./app/pages/portal/PortalHome3";
import { PortalHome4 } from "./app/pages/portal/PortalHome4";
import { createStore, persistor } from "./redux/lib/store";
import Layout from "./ui/layout/dashboard";
import SempreInformes from "./app/components/sempre/sempre-informes/sempre-informes";
import SempreImportacion from "./app/components/sempre/sempre-importacion/sempre-importacion";
import PrecargaSempreAdmin from "./app/components/sempre/precarga-sempre-admin/precarga-sempre-admin";
import ConveniosList from "./app/components/convenios/convenios-list/convenios-list";
import ConvenioViewList from "./app/components/convenios/convenio-view/convenio-view";
 

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/portal1",
        Component: PortalHome,
      },
      {
        path: "/portal2",
        Component: PortalHome2,
      },
      {
        path: "/portal3",
        Component: PortalHome3,
      },
      {
        path: "/portal4",
        Component: PortalHome4,
      },
      {
        path: "/",
        Component: Layout,
        children: [
          {
            path: "/",
            Component: DashboardPage,
          },
          {
            path: "/orders",
            Component: OrdersPage,
          },
          {
            path: "/practicas",
            Component: PracticasList,
          },
          {
            path: "/practicas/list",
            Component: PracticasList,
          },
          {
            path: "/practicas/precarga-sempre",
            Component: PrecargaSempre,
          },
          {
            path: "/practicas/informes",
            Component: PracticasInformes,
          },
          {
            path: "/practicas/enviar",
            Component: PracticasEnviar,
          },
          {
            path: "/practicas/remito-admin",
            Component: PracticasRemitoAdmin,
          },
          {
            path: "/sempre",
            Component: SempreImportacion,
          },
          {
            path: "/sempre/precarga",
            Component: PrecargaSempreAdmin,
          },
          {
            path: "/sempre/importacion",
            Component: SempreImportacion,
          },
          {
            path: "/sempre/informes",
            Component: SempreInformes,
          },
          {
            path: "/convenios",
            Component: ConveniosList,
          },
          {
            path: "/convenios/view/:id",
            Component: ConvenioViewList,
          },
        ],
      },
      {
        path: "/sign-in",
        Component: CredentialsSignInPage,
      },
    ],
  },
]);

const store = createStore("cofolp");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate persistor={persistor(store)} loading={<div>Loading...</div>}>
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
